import React, { useContext } from "react";

import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

import AddPlannedMealButton from "./AddPlannedMealButton";
import ColumnHeader from "./ColumnHeader";
import MealPlanFormStore from "../store/MealPlanFormStore";

const useStyles = makeStyles()(() => ({
  root: {
    display: "flex",
    width: "max-content", // for sticky row headers to work all the way
  },
  headerCell: {
    border: "2px solid #fafafa",
    minWidth: 400,
    maxWidth: 400,
    backgroundColor: colors.white,
  },
  rowHeader: {
    position: "sticky",
    left: 0,
    minWidth: 125,
    maxWidth: 125,
    border: "2px solid #fafafa",
    backgroundColor: colors.white,
    zIndex: 10,
  },
}));

const ColumnHeadersRow: React.FC = observer(() => {
  const { classes } = useStyles();

  const store = useContext(MealPlanFormStore.Context);

  return (
    <div className={classes.root}>
      <div className={classes.rowHeader}>
        <Box padding={2}>
          <AddPlannedMealButton />
        </Box>
      </div>
      {store.columns.map((column) => (
        <div key={column.index} className={classes.headerCell}>
          <ColumnHeader column={column} />
        </div>
      ))}
    </div>
  );
});

export default ColumnHeadersRow;
